<template>
    <div class="workorderInfromation">
        <div class="workorderInfromation_title">
            <div class="workorderInfromation_t_zhzx" :class="{'QZX':timeLineData.roleGrade=='1','ZLD':timeLineData.roleGrade=='2','ZGLD':timeLineData.roleGrade=='4','ZX':timeLineData.roleGrade=='3'}">
                {{timeLineData.czCzdwmc}}
            </div>
            <div class="workorderInfromation_t_name">
                {{timeLineData.czCzrmc}}
            </div>
            <div class="workorderInfromation_t_describe">
                督办抽查
            </div>
            <div class="workorderInfromation_t_pass" v-if="timeLineData.czCzjgzt=='1'">
                结案
            </div>
            <div class="workorderInfromation_t_reject" v-else>
                驳回
            </div>
        </div>
        <div class="workorderInfromation_progressTime">
            <span class="icon-time_fill workorderInfromation_icon"></span>
            <div class="workorderInfromation_p_time">
                {{timeLineData.czCzsj}}
            </div>
            <div class="workorderInfromation_p_day">
                第{{timeLineData.theDay}}天
            </div>
        </div>
        <div class="workorderInfromation_option">
            <span class="icon-progress workorderInfromation_icon"></span>
            <div>
                <span v-if="timeLineData.czCzjgzt=='1'" class="workorderInfromation_option_label">处置结果：</span><span v-if="timeLineData.czCzjgzt=='0'" class="workorderInfromation_option_label">驳回原因：</span>{{timeLineData.czCzjgwb}}
            </div>
        </div>
    </div>
</template>

<script>
    import TimeLine_file from "./TimeLine_file.vue"
    export default {
        name: "returnvisitInformation",
        props:["timeLineList"],
        components: {
            TimeLine_file
        },
        setup(props, context) {
            // let gdId = inject("gdId");
            // let timeLineData = reactive({
            //     "czCzdwmc": "指挥中心",//处置单位名称
            //     "czCzrmc": "张倩",  //处置人名称
            //     "czCzsj": "2021.12.02 14:11:38", //处置时间
            //     "czCzjgwb":"开发区商务金融。",
            //     "theDay": "1", //第n天"
            //     "czCzjgzt" : "1",     //审核状态（1通过0驳回）
            // })
            let timeLineData = props.timeLineList;
            return {
                timeLineData
            }
        }
    }
</script>

<style scoped>

</style>
